export default {
    dashboard: 'Dashboard',
    trendradar: 'Trend radar',
    trendfinder: 'Trend finder',
    innovationFields: 'Innovation fields',
    innovationProject: 'Innovation projects',
    workspace: 'Work spaces',
    trendUpdate: 'Trend-update',
    insights: 'Insights',
    close: 'Close',
    help: {
        title: 'Help',
        url: 'https://support.trendmanager.com/en/'
    },
    productUpdate: {
        url: 'https://support.trendmanager.com/en/product-updates/',
        title: 'Product update'
    },
    feedback: 'Feedback'
}
